// ── ChecklistCatalogPage ──
import { useState, useEffect } from "react";
import { localFilter } from "../../../shared/format";
import { Btn, Card, ErrorMsg, Icon, STh, SearchBar, SectionHeader, Spinner, Td, TdNum, Th } from "../../../shared/ui";
import { useSortable } from "../../../shared/hooks";
import { useApp } from "../../../shared/appContext";

export const ChecklistCatalogPage = () => {
    const { api, role, view, setModal, setConfirm, delRec } = useApp();
    const [rows,setRows]=useState([]); const [loading,setLoading]=useState(true); const [err,setErr]=useState(null);
    const [q,setQ]=useState("");
    const load=()=>{setLoading(true);api.get("getChecklistCatalog?all=1").then(d=>{setRows(d);setLoading(false);}).catch(e=>{setErr(e.message);setLoading(false);});};
    useEffect(()=>{load();},[]);
    const filtered=localFilter(rows,q,["category","name","responsibleparty","description"]);
    const { sorted, sortKey, sortDir, toggle } = useSortable(filtered, 'order');

    if(loading) return <Spinner />; if(err) return <ErrorMsg msg={err} onRetry={load} />;
    return <>
      <SectionHeader actions={[
        <SearchBar key="s" value={q} onChange={setQ} placeholder="Search catalog..." />,
        role.canManageUsers&&<Btn key="a" onClick={()=>setModal({type:"checklistcatalog-add",onDone:load})} variant="primary">+ Add Item</Btn>
      ].filter(Boolean)} />
      <Card style={{ overflowX:"auto" }}>
        <table style={{ width:"100%",borderCollapse:"collapse", whiteSpace:"nowrap" }}>
          <thead><tr>
            <STh label="Order"    sortKey="order"            currentKey={sortKey} currentDir={sortDir} onSort={toggle} numeric />
            <STh label="Category" sortKey="category"         currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
            <STh label="Name"     sortKey="name"             currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
            <STh label="Resp. Party" sortKey="responsibleparty" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
            <Th>Doc Req'd</Th>
            <Th>Active</Th>
            <Th></Th>
          </tr></thead>
          <tbody>{sorted.map(c=>(
            <tr key={c.id} style={{ cursor:"pointer", opacity: c.isactive===false||c.isactive===0 ? 0.5 : 1 }} onClick={()=>setModal({type:"checklistcatalog-view",rec:c})} onMouseEnter={e=>e.currentTarget.style.background="var(--color-background-secondary)"} onMouseLeave={e=>e.currentTarget.style.background=""}>
              <TdNum>{c.order??"—"}</TdNum>
              <Td>{c.category||"—"}</Td>
              <Td style={{ fontWeight:500 }}>{c.name||"—"}</Td>
              <Td>{c.responsibleparty||"—"}</Td>
              <Td>{c.documentrequired?"✓":"—"}</Td>
              <Td>{(c.isactive===false||c.isactive===0)?"—":"✓"}</Td>
              <Td><div style={{ display:"flex",gap:6, justifyContent:"flex-end" }} onClick={e=>e.stopPropagation()}>
                <Btn onClick={()=>setModal({type:"checklistcatalog-view",rec:c})}><Icon type="view" /></Btn>
                {role.canManageUsers&&<Btn onClick={()=>setModal({type:"checklistcatalog-edit",rec:c,onDone:load})}><Icon type="edit" /></Btn>}
                {role.canManageUsers&&<Btn onClick={()=>setConfirm({msg:"Delete this catalog item? If it's been used in a checklist, deactivate it instead.",onConfirm:()=>delRec("ChecklistCatalog",c.id,"Deleted catalog item",load)})} variant="danger"><Icon type="delete" /></Btn>}
              </div></Td>
            </tr>
          ))}</tbody>
        </table>
      </Card>
    </>;
  };
